import clsx from 'clsx';
import { IconCheckBold, IconSubtractBold } from '../../../icons/index.js';
import type { CommonProps } from '../../types.js';

interface CheckboxIndicatorProps extends CommonProps {
  isSelected?: boolean;
  isIndeterminate?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isInvalid?: boolean;
  isHovered?: boolean;
  isPressed?: boolean;
  isFocusVisible?: boolean;
}

/**
 * Displays a non-interactive, purely visual checkbox indicator.
 *
 * @internal
 */
export function CheckboxIndicator({
  isSelected,
  isIndeterminate,
  isDisabled,
  isReadOnly,
  isInvalid,
  isHovered,
  isPressed,
  isFocusVisible,
  UNSAFE_className,
  UNSAFE_style,
  ...props
}: CheckboxIndicatorProps) {
  return (
    <div
      {...props}
      className={clsx('cim-checkbox-indicator', UNSAFE_className)}
      style={UNSAFE_style}
      data-selected={isSelected || undefined}
      data-indeterminate={isIndeterminate || undefined}
      data-disabled={isDisabled || undefined}
      data-readonly={isReadOnly || undefined}
      data-invalid={isInvalid || undefined}
      data-hovered={isHovered || undefined}
      data-pressed={isPressed || undefined}
      data-focus-visible={isFocusVisible || undefined}
      aria-hidden
    >
      <div className="cim-checkbox-indicator-icon">{isIndeterminate ? <IconSubtractBold /> : <IconCheckBold />}</div>
    </div>
  );
}

CheckboxIndicator.displayName = 'CheckboxIndicator';
